import { Box, IconButton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useTranslation } from 'react-i18next';
import AboutService from "../../Services/OnePageServices";
import i18n, { _get_i18Lang } from '../../i18n';
import shareicon from "../../svg/share.svg";
import gitasevaLogo from "../../svg/gitasevaLogo.svg";
import { HeaderBox } from './mBookListPage';
const MobilePromotion = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [promotionList, setPromotionList] = useState<any[]>([]);

    useEffect(() => {
        AboutService.getPromotionPageData(_get_i18Lang()).then((result: any) => {
            if (result?.result?.length > 0) {
                setPromotionList(result.result);

            }
        });
    }, [i18n.language]);

    return (
        <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            {/* Header */}
            <HeaderBox>
                <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
                    <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
                </IconButton>
                <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
                    <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
                </IconButton>
                <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
                    {t("shrihari_tr")}
                </Typography>
                <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
                    {t("promotion_tr")}
                </Typography>
            </HeaderBox>
            <Box sx={{ flex: 1, overflowY: 'auto', paddingBottom: '60px', '&::-webkit-scrollbar': { display: 'none' }, msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
                <div style={{ width: "100%", fontSize: "10px" }}>
                    <div
                        style={{
                            width: "100%",
                            padding: 8,
                            marginTop: 0,
                            backgroundColor: "rgb(255, 237, 188)",
                            paddingTop: 20,
                            borderBottomLeftRadius: '12%',
                            borderBottomRightRadius: '12%',
                            borderBottom: '5px solid #f97316'
                        }}>

                        {promotionList[0]?.promotionContent && (
                            <div
                                className='html-content'
                                dangerouslySetInnerHTML={{ __html: promotionList[0].promotionContent }}
                            />
                        )}

                        <div
                            style={{
                                border: '1.9px solid #f97316',
                                width: 'fit-content',
                                height: "60px",
                                padding: '4px 13px',
                                borderRadius: 6,
                                backgroundColor: '#ffa50038',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '20px auto',
                                gap: 8,
                            }}
                        >
                            <img
                                src={shareicon}
                                width={20}
                                alt="share"
                                style={{
                                    filter:
                                        'invert(44%) sepia(93%) saturate(2296%) hue-rotate(1deg) brightness(102%) contrast(101%)',
                                }}
                            />
                            <p style={{ fontSize: '18px', margin: 0, color: "#f97316", fontWeight: 600 }}>{t('shareApp_tr')}</p>
                            <img
                                style={{ marginTop: '-10px' }}
                                src={gitasevaLogo}
                                width={80}
                                height={80}
                                alt='gitaseva'
                            />
                        </div>

                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        padding: 16,
                        marginTop: 20,
                        flexWrap: 'wrap',
                        gap: 12,
                    }}>
                        {promotionList.length > 0 && (
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-around',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: 12,
                            }}>
                                {promotionList.map((item, index) => (
                                    item.promotionPath && (
                                        <div
                                            key={index}
                                            style={{ width: '45%', textAlign: 'center', cursor: 'pointer' }}
                                            onClick={() => {

                                                if (
                                                    item.name?.includes("अंग्रेज़ी") ||
                                                    item.name?.toLowerCase().includes("english")
                                                ) {
                                                    navigate('/pamphletEng');
                                                } else {
                                                   navigate('/pamphletHindi');
                                                }
                                            }}
                                        >
                                            <img
                                                src={item.promotionPath}
                                                alt={item.name}
                                                style={{ width: '100%', borderRadius: 8 }}
                                            />

                                            <h6 className='mt-2' style={{ fontSize: 18, color: '#444', fontWeight: 500 }}>
                                                {item.name}
                                            </h6>
                                        </div>
                                    )
                                ))}

                            </div>
                        )}

                    </div>
                </div>
            </Box>
        </Box>
    )
}

export default MobilePromotion;
